import styled from "styled-components";
import { SmallPrint } from "../../../styles/typography/SmallPrint.styled";

export const Error = styled(SmallPrint)`
  color: ${({ theme }) => theme.colors.alert};
`;
